import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2857d14e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-container" }
const _hoisted_2 = { class: "skeleton-box" }

import {ref} from 'vue';
import {List, Toast, Skeleton} from 'vant';
import CustomEmpty from '@/components/CustomEmpty.vue';
import CustomDialog from '@/components/CustomDialog.vue';
import {useCommentDelete} from '@/service/comment';
import {useUserInfo} from '@/hooks/useUserInfo';
import CommonPopup from '@/components/CommonPopup.vue';
import Item from './Item.vue';


const __default__ = {
  name: 'Comment',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    detailData: null,
    listData: null,
    firstPageFetching: { type: Boolean },
    firstPageFinished: { type: Boolean },
    firstPageError: null,
    firstPageRefetch: null,
    total: null,
    isRefresh: { type: Boolean },
    changeIsRefresh: null,
    newPublishCommentNumber: null,
    canComment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  detailData: InfoItem;
  listData: { commentDetail: CommentDetail }[];
  firstPageFetching: boolean;
  firstPageFinished: boolean;
  firstPageError: any;
  firstPageRefetch: any;
  total: number;
  isRefresh: boolean;
  changeIsRefresh:(refresh: boolean) => void;
  newPublishCommentNumber: string;
  canComment:boolean;
}



// 控制删除弹出层
const isShowPopup = ref<boolean>(false);
const isDeletingCommentInfo = ref<{ commentId: string; userId: number }>({
  commentId: '',
  userId: 0,
});
const {userId: curUserId} = useUserInfo();
const showPopup = (commentId: string, userId: number) => {
  if (curUserId === userId) {
    isDeletingCommentInfo.value.commentId = commentId;
    isDeletingCommentInfo.value.userId = userId;
    isShowPopup.value = true;
  }
};
const hidePopup = () => {
  isShowPopup.value = false;
};
const handlePopupDelete = () => {
  hidePopup();
  // fix: 两个弹窗类组件显示异常
  let timer: number | null = setTimeout(() => {
    toggleShowDialog(true);
    clearTimeout(timer!);
    timer = null;
  }, 30);
};
// 控制确认弹框
const isShowDialog = ref<boolean>(false);
const toggleShowDialog = (show: boolean) => {
  isShowDialog.value = show;
};
const handleConfirm = () => {
  useCommentDelete(isDeletingCommentInfo.value.commentId!, () => {
    props.changeIsRefresh(true);
    props.firstPageRefetch().then(() => {
      props.changeIsRefresh(false);
      Toast.success('删除成功');
    });
  });
};

const errorBtnClick = () => {
  props.firstPageRefetch();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, " 评论" + _toDisplayString((__props.firstPageFinished && !__props.firstPageError) || __props.isRefresh
        ? __props.total <= 999
          ? `（${__props.total}）`
          : '（999+）'
        : ''), 1),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Skeleton), {
        avatar: "",
        row: 3
      }),
      _createVNode(_unref(Skeleton), {
        avatar: "",
        row: 3
      }),
      _createVNode(_unref(Skeleton), {
        avatar: "",
        row: 3
      })
    ], 512), [
      [_vShow, (!__props.firstPageFinished || __props.firstPageFetching) && !__props.isRefresh]
    ]),
    (__props.listData?.length > 0)
      ? (_openBlock(), _createBlock(_unref(List), { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listData, (item) => {
              return (_openBlock(), _createBlock(Item, {
                key: item?.commentDetail.commentNumber,
                "comment-info": item?.commentDetail,
                "show-popup": showPopup,
                "is-highlight": 
          __props.newPublishCommentNumber === item?.commentDetail.commentNumber
        
              }, null, 8, ["comment-info", "is-highlight"]))
            }), 128)),
            _createVNode(CommonPopup, {
              "manage-text": "删除评论",
              "is-show-popup": isShowPopup.value,
              "handle-manage": handlePopupDelete,
              "hide-popup": hidePopup
            }, null, 8, ["is-show-popup"]),
            _createVNode(CustomDialog, {
              teleport: ".detail-page",
              description: "是否确认删除",
              show: isShowDialog.value,
              "toggle-show-dialog": toggleShowDialog,
              "on-confirm": handleConfirm
            }, null, 8, ["show"])
          ]),
          _: 1
        }))
      : (__props.firstPageError)
        ? (_openBlock(), _createBlock(CustomEmpty, {
            key: 1,
            type: "error",
            class: "empty",
            description: "哎呀！评论加载发生意外",
            "on-click-btn": errorBtnClick,
            "hide-img": ""
          }))
        : (__props.firstPageFinished && __props.listData?.length === 0)
          ? (_openBlock(), _createBlock(CustomEmpty, {
              key: 2,
              type: "none",
              class: "empty empty-txt",
              "hide-img": "",
              description: __props.canComment? '还没有评论，发表第一条吧!' : '评论区已关闭'
            }, null, 8, ["description"]))
          : _createCommentVNode("", true)
  ]))
}
}

})